@for (month of monthDates(); track month.getDate()) {
  <a
    (click)="setMonth(month.getMonth())"
    [class.active]="month.getMonth() === monthSelected()"
    id="v-pills-home-tab"
    data-toggle="pill"
    role="tab"
    aria-controls="v-pills-home"
    aria-selected="true"
  >
    {{ month | date }}
  </a>
}
